import { mutate } from 'swr';
import axios from 'axios';
import { Notistack } from '@shared/components/Notistack/Notistack';
import { getError } from '@shared/utils/helpers';
import { SERVICES } from '@shared/constants/apiConfig';
import { IRole } from './shared';
import { IRoleAssignmentRequest } from './RoleModal/models/RoleAssignmentModel';

const rolesPath = `/${SERVICES.USER}/roles`;
const roleAssignmentPath = `/${SERVICES.USER}/roleAssignment`;

export const requestCreateRole = (role: IRole) => {
  return mutate(rolesPath, async() => {
    try {
      await axios.post(rolesPath, role);
      Notistack.successMessage('Role - Created Successfully');
    } catch (err) {
      Notistack.generalError(getError(err));
    }
  });
};

export const requestUpdateRole = (role: IRole) => {
  return mutate(rolesPath, async() => {
    try {
      await axios.put(`${rolesPath}/${role.id}`, role);
      Notistack.successMessage('Role - Updated Successfully');
    } catch {
      Notistack.generalError();
    }
  });
};

export const requestDeleteRole = (roleId = '') => {
  return mutate(rolesPath, async() => {
    try {
      await axios.delete(`${rolesPath}/${roleId}`);
      Notistack.successMessage('Role - Deleted Successfully');
    } catch {
      Notistack.generalError();
    }
  });
};

export const requestUpdateRoleAssignment = (roleId: string, roleAssignment: IRoleAssignmentRequest) => mutate(
  [roleAssignmentPath, `${roleAssignmentPath}/roleAssignmentSelections`], async() => {
    try {
      await axios.put(`${roleAssignmentPath}/${roleId}`, { ...roleAssignment });
      Notistack.successMessage('Role Assignment - Updated Successfully');
    } catch {
      Notistack.generalError();
    }
  }
);
